/** @format */

import React, { useEffect, useState } from 'react';
import { Button, CardActions, CircularProgress } from '@mui/material';
import { PageContainer, Icons } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import { useStyles } from './Style';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useBusiness } from 'hooks';
import { serviceCallAddApi } from '../services/WebServiceServices';
import createToast from 'components/Toast/Toast';

import {
  CalculationMethod,
  Beneficiary,
  GeneralInfo,
  HeaderParameters,
  BodyParameters,
  Agreement,
} from './components';
import ErrorHandlingBlocks from '../ErrorHandlingBlocks';
import { constBreadCrumbsTitle } from 'utility';

const DefineWebService = () => {
  const defaultValues = {
    scType: 'REST',
    currentVersion: 1,
    scHttpStatusCode: 200,
    scAutoApprove: 'true',
  };
  const navigate = useNavigate();

  const myBusinessInfo = useBusiness();

  const methods = useForm({ defaultValues });
  const { handleSubmit, formState: { errors } } = methods;

  const [expanded, setExpanded] = useState('general');
  const [selected, setSelected] = useState({});
  const [agreementStatus, setAgreementStatus] = useState(true);
  const [loading, setLoading] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);


  const classes = useStyles();

  const selectChange = (name, e) => {
    setSelected((prevState) => {
      return { ...prevState, [name]: e.target.value };
    });
  };

  const typeOfBody = {
    optional: {
      scHiddenParameter: false,
      scIsRequired: false,
    },
    required: {
      scHiddenParameter: false,
      scIsRequired: true,
    },
    hidden: {
      scHiddenParameter: true,
      scIsRequired: false,
    },
  };

  const generateBodyData = (data) => {
    if (Array.isArray(data)) {
      return data.map(generateBodyData);
    }
    data = { ...data, ...typeOfBody[data.typeOfBody] };

    delete data.typeOfBody;
    if (data?.scParameters) {
      data = {
        ...data,
        scParameters: [...generateBodyData(data.scParameters)],
      };
    }
    return data;
  };

  const onSubmit = (data) => {
    let dataBody = [];
    if (data?.scInputParams) {
      dataBody = generateBodyData(data.scInputParams);
    }

    const metaDataObj = {
      scGuildCode: typeof data.scGuildCode === 'object' ? data.scGuildCode.code : data.scGuildCode,
      scNamespace: data.scNamespace ? data.scNamespace : null, // *  فضای نام در این بخش وارد میشود که معمولا همان اکشن میباشد
      scUrl: data.scUrl, // *
      scMethodName: data.scMethodName ? data.scMethodName : null, // soap method
      scInputParams: dataBody.length ? dataBody : null, // body  ----- JSON.stringify(data.serviceParams);
      scHeaderParams: data.scHeaderParams ? data.scHeaderParams : [], // *
      scType: data.scType,
      scEnName: data.scEnName, // *
      scProvider: data.scProvider, // *
      scFaName: data.scFaName, // *
      scHttpVerb: data.scHttpVerb, // *
      scPriceCalculationType: data.scPriceCalculationType, // *
      scPriceHeader: data.scPriceHeader ? data.scPriceHeader : '', //
      scPriceInquiryUrl: data.scPriceInquiryUrl ? data.scPriceInquiryUrl : '',
      scPaymentType: 'SUBSCRIPTIONPLAN', // data.scPaymentType
      scStakeholderList: data.scStakeholderList || [],
      scAutoApprove: false,
      scClientId: '',
      scSuccessfulResult: {
        scHttpStatusCode: data.scHttpStatusCode || '',
        scHttpResponse: data.scHttpResponse || '',
      },
    };

    if (data.scAutoApprove === 'true') {
      metaDataObj.scClientId =
        typeof data.scClientId === 'object' ? data.scClientId.client_id : data.scClientId;
      metaDataObj.scAutoApprove = true;
    }

    if (data.scStakeholderList) {
      let sumPercentage = 0;
      let myBusinessIdExist = false;

      metaDataObj.scStakeholderList = data.scStakeholderList.map((item) => {
        if (item.percentage) {
          sumPercentage += +item.percentage;
          myBusinessIdExist = item.businessId.id === myBusinessInfo.id || myBusinessIdExist;
        }
        return {
          ...item,
          businessId: item.businessId.id,
        };
      });

      if (sumPercentage > 0 && sumPercentage < 100 && !myBusinessIdExist) {
        alert(
          'برای درصد تسهیم کمتر از صد در صد باید کسب‌وکار خود را هم به عنوان یکی از ذینفعان تعریف نمایید.',
        );
        return;
      }
    }

    if (data.contentType) {
      metaDataObj.scHeaderParams.push({
        scParameterName: 'content-type',
        scParameterDesc: '',
        scParameterDefaultValue:
          typeof data.contentType === 'object' ? data.contentType.value : data.contentType,
        scIsRequired: 'false',
        scHiddenParameter: 'true',
        scParameterLogMode: 'LOGGABLE',
      });
    }

    const dataServiceCall = {
      preferredTaxRate: '0',
      price: data.price,
      enable: 'true',
      unlimited: 'true',
      serviceVersion: data.currentVersion,
      ...metaDataObj,
      description: data.description,
      status: 'pending',
      scProvider: data.scProvider,
    };

    if (data?.providerBusinessId) {
      dataServiceCall.providerBusinessId = data?.providerBusinessId.id;
    }

    const dataApi = {
      dataServiceCall,
      serviceSetId: data.serviceSet.map((val) => val.id),
    };

    async function addServiceCall(params) {
      let result;

      try {
        setLoading(true);

        result = await serviceCallAddApi(params);
        const dataRes = result.data;

        createToast('خطا', dataRes?.message || 'خطا در ثبت مجددا تلاش نمایید.!', 'danger');

        setOpenSnack(true);
        setLoading(false);

        createToast('موفق', 'تعریف سرویس با موفقیت افزوده شد.', 'success');

        setOpenSnack(true);
        navigate('/WebService');
      } catch (error) {
        setOpenSnack(true);
        setLoading(false);
      }
    }

    addServiceCall(dataApi);
  };

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const openPanel = (panel) => {
    setExpanded(panel);
  };

  useEffect(() => {
    if (Object.keys(errors).length) {
      ErrorHandlingBlocks(errors, openPanel);
    }
  }, [errors]);


  return (
    <PageContainer title="تعریف سرویس جدید" breadcrumbs={constBreadCrumbsTitle.WEBSERVICE_ADD}>
      {!agreementStatus && <Agreement setAgreementStatus={setAgreementStatus} />}
      {agreementStatus && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
            <Accordion expanded={expanded === 'general'} onChange={handleChange('general')}>
              <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<Icons icon="CaretDown" color="#667585" size="20" />}
              >
                <Typography className={classes.heading}>اطلاعات کلی وب سرویس</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <GeneralInfo selected={selected} selectChange={selectChange} classes={classes} />
              </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'body'} onChange={handleChange('body')}>
              <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<Icons icon="CaretDown" color="#667585" size="20" />}
              >
                <Typography className={classes.heading}>پارامترهای body</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <BodyParameters
                  selected={selected}
                  selectChange={selectChange}
                // classes={classes}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'header'} onChange={handleChange('header')}>
              <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<Icons icon="CaretDown" color="#667585" size="20" />}
              >
                <Typography className={classes.heading}>پارامترهای Header</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <HeaderParameters
                  selected={selected}
                  selectChange={selectChange}
                  classes={classes}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'calculation'} onChange={handleChange('calculation')}>
              <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<Icons icon="CaretDown" color="#667585" size="20" />}
              >
                <Typography className={classes.heading}>روش محاسبه</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CalculationMethod
                  selected={selected}
                  selectChange={selectChange}
                  classes={classes}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'beneficiary'} onChange={handleChange('beneficiary')}>
              <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<Icons icon="CaretDown" color="#667585" size="20" />}
              >
                <Typography className={classes.heading}>ذینفعان</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Beneficiary selected={selected} selectChange={selectChange} classes={classes} />
              </AccordionDetails>
            </Accordion>

            <CardActions className={classes.CardActions}>
              <Button type="submit" color="primary" variant="contained" disabled={loading}>
                ثبت
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </Button>
              <Button variant="contained" onClick={() => navigate('/WebService')}>
                انصراف
              </Button>
            </CardActions>
          </form>
        </FormProvider>
      )}
    </PageContainer>
  );
};

export default DefineWebService;
